import CurrencySwitch from '@/components/common/CurrencySwitch';
import InstrumentInfo, { formConfig } from '@/components/common/InstrumentInfo';
import { UseOrderExecutionReturn } from '@/utils/hooks/useOrderExecution';

type OrderExecutionReturn = Omit<UseOrderExecutionReturn, 'activePair'>;

interface FormCurrencyProps extends OrderExecutionReturn {
    currency: string;
    setCurrency: (currency: string) => void;
}

const FormCurrency = (props: FormCurrencyProps) => {
    const { currency, instrument, ccy1Config, ccy2Config, setCurrency, orderMessage, pairMapToUse } = props;
    const { ccy2_enabled } = instrument;

    return (
        <div className="flex justify-between items-center gap-1 flex-wrap">
            <div className="flex items-center gap-1 text-sm md:text-base">
                <span className="whitespace-nowrap">{orderMessage}</span>
                <InstrumentInfo market={pairMapToUse} {...formConfig} />
            </div>
            <CurrencySwitch
                value={currency}
                instrument={instrument}
                baseCurrency={ccy1Config}
                quoteCurrency={ccy2Config}
                disabled={!ccy2_enabled}
                onChange={setCurrency}
            />
        </div>
    );
};

export default FormCurrency;
